import { Outlet } from "react-router-dom";
import GlobalStyle from "./styles/global.style";
import QuickMenu from "./components/app/QuickMenu";
import Footer from "./components/app/Footer";
import ScrollToTop from "./components/app/ScrollTop";

function App() {
  return (
    <div>
      <GlobalStyle />
      <ScrollToTop />
      <Outlet />
      <QuickMenu />
      <Footer />
    </div>
  );
}

export default App;
